import { Box } from '@mui/material'
import Header from 'components/Header/Header'
import PageLoading from 'components/PageLoading'
import React, { useContext } from 'react'
import AuthContext from './AuthContext'

const RequireAuth = ({ children }: React.PropsWithChildren) => {
    const { isUserLogged } = useContext(AuthContext)
    if (!isUserLogged) {
        return <PageLoading />
    }

    return (
        <Box>
            <Header />
            {children}
        </Box>
    )
}

export default RequireAuth